const { REACT_APP_BASE_URL } = process.env;

const envConfig = {
  baseUrl: REACT_APP_BASE_URL,
};

export default envConfig;
